var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { createInputAllocationPayload, createInputAmountPayloadLegacy, } from './events/utils';
export function getLinkVersion() {
    return window.__LINK_VERSION__;
}
export function getSuccessPayload(version, state) {
    var isDds = state.linkApi.jobType === 'direct_deposit_switch';
    var accountId = state.linkApi.accountId;
    var platformId = state.linkApi.context.platform.id;
    var job = state.linkApi.jobType;
    if (version === '2.3.0') {
        var successPayload = {
            accountId: accountId,
            platformId: platformId,
            job: job,
        };
        if (isDds)
            successPayload.params = {
                amount: createInputAmountPayloadLegacy(state.amountSelection),
            };
        return successPayload;
    }
    return __assign({ accountId: state.linkApi.accountId, platformId: state.linkApi.context.platform.id, job: state.linkApi.jobType }, (isDds
        ? { params: createInputAllocationPayload(state.amountSelection) }
        : null));
}
function _getSdkMiddleware(version, externalHandler) {
    return function (eventName, payload) {
        if (version === '2.3.0') {
            if (eventName === 'input_allocation' &&
                'action' in payload &&
                payload.action === null)
                return;
            externalHandler(eventName, payload);
        }
        else if (version === '3.0.0') {
            if (eventName === 'input_amount')
                return;
            externalHandler(eventName, payload);
        }
    };
}
export default function getSdkMiddleware(version, externalHandler) {
    return _getSdkMiddleware(version, externalHandler);
}
